// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3avCY","heading":"styles__heading___2ZhaU","title":"styles__title___3wLje","subTitle":"styles__subTitle___2nwnh","list":"styles__list___2Khad"};